import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import API_URL from "../apiConfig";

import Seo from "../components/Seo";

import "../CSS/index.css";


function NewsPage() {

    const [news, setNews] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");


    // ==================================================
    // BILDPFAD ERZEUGEN
    // ==================================================

    function getNewsImagePath(imageValue) {

        if (!imageValue) {
            return "";
        }

        if (imageValue.startsWith("/")) {
            return imageValue;
        }

        if (
            imageValue.startsWith("http://") ||
            imageValue.startsWith("https://")
        ) {
            return imageValue;
        }

        return `/Fotos/news/${imageValue}`;
    }


    // ==================================================
    // NEWS VON DER PHP-API LADEN
    // ==================================================

    useEffect(() => {

        fetch(
            `${API_URL}/news.php`
        )

            .then((response) => {

                if (!response.ok) {

                    throw new Error(
                        "News konnten nicht geladen werden."
                    );
                }

                return response.json();
            })

            .then((data) => {

                setNews(data);
                setIsLoading(false);
            })

            .catch((error) => {

                setError(error.message);
                setIsLoading(false);
            });

    }, []);


    // ==================================================
    // NEUESTE NEWS
    // ==================================================

    const newestArticle =
        news.length > 0
            ? news[0]
            : null;


    const olderArticles =
        news.length > 1
            ? news.slice(1)
            : [];


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <Seo
                title="News"
                description="Aktuelle Neuigkeiten von Ivan Jörg über Projekte, Weiterbildungen, berufliche Themen und persönliche Interessen."
                canonical="https://www.irj.ch/"
            />


            <div className="intro">

                <h1>
                    Persönliche Webseite von Ivan Jörg
                </h1>

                <p>
                    Herzlich willkommen auf meiner persönlichen Webseite.
                    Hier findest Du aktuelle Neuigkeiten über meine Projekte,
                    Weiterbildungen, beruflichen Themen und persönlichen
                    Interessen.
                </p>

            </div>


            <main className="news-main">

                {
                    isLoading && (

                        <p>
                            News werden geladen...
                        </p>

                    )
                }


                {
                    error && (

                        <p>
                            {error}
                        </p>

                    )
                }


                {
                    !isLoading &&
                    !error &&
                    news.length === 0 && (

                        <p>
                            Zurzeit sind keine News vorhanden.
                        </p>

                    )
                }


                {
                    !isLoading &&
                    !error &&
                    newestArticle && (

                        <>

                            {/* ================================= */}
                            {/* AKTUELLE NEUIGKEIT */}
                            {/* ================================= */}

                            <h2 className="news-aktuell-titel">
                                Aktuelle Neuigkeit
                            </h2>


                            <section className="news-highlight">

                                {
                                    newestArticle.bild && (

                                        <div className="news-highlight-bild">

                                            <img
                                                src={
                                                    getNewsImagePath(
                                                        newestArticle.bild
                                                    )
                                                }
                                                alt={
                                                    newestArticle.titel
                                                }
                                            />

                                        </div>

                                    )
                                }


                                <div className="news-highlight-inhalt">

                                    <span className="news-datum">
                                        {newestArticle.datum}
                                    </span>


                                    <h1>
                                        {newestArticle.titel}
                                    </h1>


                                    <p>
                                        {newestArticle.kurztext}
                                    </p>


                                    <Link
                                        className="news-link"
                                        to={`/news/${newestArticle.id}`}
                                    >
                                        Mehr erfahren →
                                    </Link>

                                </div>

                            </section>


                            {/* ================================= */}
                            {/* WEITERE NEUIGKEITEN */}
                            {/* ================================= */}

                            {
                                olderArticles.length > 0 && (

                                    <>

                                        <h2 className="news-weitere-titel">
                                            Weitere Neuigkeiten
                                        </h2>


                                        <section className="news-grid">

                                            {
                                                olderArticles.map(
                                                    (article) => (

                                                        <article
                                                            className="news-card"
                                                            key={article.id}
                                                        >

                                                            {
                                                                article.bild && (

                                                                    <div className="news-card-bild">

                                                                        <img
                                                                            src={
                                                                                getNewsImagePath(
                                                                                    article.bild
                                                                                )
                                                                            }
                                                                            alt={
                                                                                article.titel
                                                                            }
                                                                        />

                                                                    </div>

                                                                )
                                                            }


                                                            <div className="news-card-inhalt">

                                                                <span className="news-datum">
                                                                    {article.datum}
                                                                </span>


                                                                <h3>
                                                                    {article.titel}
                                                                </h3>


                                                                <p>
                                                                    {article.kurztext}
                                                                </p>


                                                                <Link
                                                                    className="news-link"
                                                                    to={`/news/${article.id}`}
                                                                >
                                                                    Mehr lesen →
                                                                </Link>

                                                            </div>

                                                        </article>

                                                    )
                                                )
                                            }

                                        </section>

                                    </>

                                )
                            }

                        </>

                    )
                }

            </main>

        </>

    );
}


export default NewsPage;